import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import Baggage from './../models/Baggage';

export function getBaggage(params) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.BAGGAGE_LIST,
        params: params,
        parser: baggagesDataParser,
    }).get();
}

export function getBaggageDetail(id) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.BAGGAGE_DETAIL,
        endpointParams: { id },
        parser: (data) => new Baggage(data.data),
    }).get();
}

export function createBaggageDetail(baggage) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.BAGGAGE_CREATE,
        parser: (data) => new Baggage(data.baggage),
    }).post(baggage.export());
}

export function updateBaggageDetail(baggage) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.BAGGAGE_ACTION,
        endpointParams: { id: baggage.id },
        parser: (data) => new Baggage(data.baggage),
    }).put(baggage.export());
}

export function deleteBaggageDetail(baggage) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.BAGGAGE_DETAIL,
        endpointParams: { id: baggage.id }
    }).delete();
}

const baggagesDataParser = (data) => ({
    result: (data.data.result || data.data).map(item => new Baggage(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})